module.exports = __webpack_public_path__ + "static/media/AvertaStd-Semibold.219469c8.woff";